export default __webpack_public_path__ + "static/media/yellow_push_cut.24d232bf.png";